import { useEffect, useState } from "react";
import { Reveal, Overline } from "./Reveal";
import { GALLERY } from "../../data/content";
import { api, resolveImg } from "../../lib/api";

export const Gallery = () => {
  const [images, setImages] = useState(null);

  useEffect(() => {
    api
      .get("/gallery")
      .then((r) => setImages(r.data.length ? r.data.map((g) => ({ id: g.id, src: resolveImg(g.image_url) })) : GALLERY.map((s, i) => ({ id: i, src: s }))))
      .catch(() => setImages(GALLERY.map((s, i) => ({ id: i, src: s }))));
  }, []);

  const list = images || GALLERY.map((s, i) => ({ id: i, src: s }));

  return (
    <section id="gallery" data-testid="gallery-section" className="relative py-28 lg:py-40 bg-[#080808]">
      <div className="max-w-[88rem] mx-auto px-5 sm:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
          <div>
            <Reveal><Overline>In the Moment</Overline></Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-6 font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tighter">
                Gallery of <span className="text-gold-gradient italic">grace</span>
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.1}>
            <p className="text-white/50 max-w-sm">Moments from the stage, the sanctuary, and the sisterhood.</p>
          </Reveal>
        </div>

        <div className="columns-1 sm:columns-2 lg:columns-3 gap-5 [column-fill:_balance]">
          {list.map((item, i) => (
            <Reveal key={item.id} delay={(i % 3) * 0.06} className="mb-5 break-inside-avoid">
              <div
                data-testid={`gallery-item-${i}`}
                className={`group relative overflow-hidden rounded-sm border border-white/10 ${
                  i % 5 === 0 ? "aspect-[3/4]" : i % 3 === 0 ? "aspect-[4/5]" : "aspect-[4/3]"
                }`}
              >
                <img
                  src={item.src}
                  alt={`Gallery ${i + 1}`}
                  loading="lazy"
                  className="w-full h-full object-cover grayscale-[0.2] group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700 ease-out"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-transparent transition-colors duration-500" />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
